export enum EProductFormat {
    RECTO = 'RECTO',
    RECTO_VERSO = 'RECTO_VERSO',
}
